/**
 * Meta (Facebook) Pixel — loaded only when VUE_APP_ENV=production (e.g. https://clinchsa.co.za/).
 * Marketing pixel ID from Events Manager; override via VUE_APP_META_PIXEL_ID if needed.
 */

const META_PIXEL_ID = (process.env.VUE_APP_META_PIXEL_ID || '2876195042727709').trim()

let initStarted = false

export function isMetaPixelEnabled() {
  return process.env.VUE_APP_ENV === 'production' && META_PIXEL_ID.length > 0
}

function ensureFbqStub() {
  if (typeof window === 'undefined' || window.fbq) return

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    s.parentNode.insertBefore(t, s)
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
  /* eslint-enable */
}

/** Inject fbevents.js stub once; safe to call multiple times. */
export function initMetaPixel() {
  if (!isMetaPixelEnabled() || initStarted || typeof window === 'undefined') return
  initStarted = true

  ensureFbqStub()
  window.fbq('init', META_PIXEL_ID)
}

/** Fire PageView — used on initial load and Vue Router navigations. */
export function trackMetaPageView() {
  if (!isMetaPixelEnabled() || typeof window === 'undefined') return
  if (!window.fbq) {
    initMetaPixel()
  }
  if (typeof window.fbq === 'function') {
    window.fbq('track', 'PageView')
  }
}
